import { restClient } from '@/core/api/rest-client'
import { getCurrentLanguage } from '@/core/i18n'
import { appConfig } from '@/shared/config/app-config'

export const SUPPORT_EMAIL = appConfig.supportEmail

interface SupportTicketRequest {
  name: string
  email: string
  message: string
  subject?: string
}

export async function sendSupportTicket(
  request: SupportTicketRequest,
): Promise<boolean> {
  try {
    // The one ticket format, shared with both phones — see leaply-kmp SupportTicketFactory.
    // Loaded on send: the shared core is too large for the entry chunk this module sits in.
    const { buildSupportTicketJson } = await import('@/shared/lib/support-core')
    // Parsed back rather than posted as it stands: the shared factory owns the shape and the
    // footer, restClient owns the transport, and it serialises whatever it is handed.
    const ticket: unknown = JSON.parse(
      buildSupportTicketJson(
        request.email,
        request.message,
        navigator.userAgent,
        // A browser tells us neither, and the footer omits a blank field rather than
        // printing an empty one.
        '',
        '',
        getCurrentLanguage(),
        request.subject ?? appConfig.supportTicketSubjects.default,
        request.name || 'No name',
      ),
    )
    await restClient.post('/v1/support/tickets', ticket)
    return true
  } catch {
    return false
  }
}
